<template>
  <div id='setting'>
       <NavTop title='设置'/>
       <van-cell-group inset>
       <van-cell title="个人信息" is-link @click="go('/myprofile')"/>
       <van-cell title="账号与安全" is-link @click="go('/security')" />
       <van-cell title="银行卡绑定" is-link @click="go('/bindcard')" />
       <van-cell title="绑定支付宝" is-link @click="go('/bindalipay')"/>
       <van-cell title="推荐人">
          <template>
               <div class="title-right">{{parentname}}</div>
          </template>
       </van-cell>
       <van-cell title="个人隐私" is-link @click="goDoc(3)"/>
       <van-cell title="关于我们" is-link @click="goDoc(7)"/>
       <van-cell>
          <template #title>
            <div class="title-center" @click="doExit">退 出</div>
          </template>
       </van-cell>
     </van-cell-group>
  </div>
</template>
<script>
import {Cell, CellGroup } from 'vant'
import NavTop from '@/components/navtop'


export default {
   name: 'setting',
   data() {
        return {
            parentname:''
        };
   }, 
   created(){
        this.getList(); 
   },
   methods: {
      getList(){
           this.$post("/user/getParentInfo",{}).then((data)=>{
                 if(data.result.success){
                     this.parentname=data.result.info.username
                 }
           })
      },
      doExit(){
          this.$store.dispatch("doLogout")
          this.$go("/login")
          setTimeout(()=>window.location.reload(true),500)
      },
      go(url){
         this.$go(url)
      },
      goDoc(type){
         this.$go("/article/"+type)
      }
   },
   components: {
        [Cell.name]:Cell,
        [CellGroup.name]:CellGroup,
        NavTop
   }
}
</script>
<style scoped>
#setting{background-color:#F6F6F6;min-height: 100vh;}
::v-deep .van-cell__title, .van-cell__value{text-align: left;}
.title-center{text-align: center!important;}
.title-right{text-align: right!important;}
::v-deep .van-cell-group--inset{margin:0 0.25rem;}

</style>